export class FileMediaData {
	fileMetaDataId: string
}



// WEBPACK FOOTER //
// ./src/app/models/file-media-data.model.ts